import { Phone, MessageCircle } from "lucide-react";
import { TEL_HREF, WHATSAPP_HREF } from "@/lib/ascentix";

export default function StickyMobile() {
  return (
    <div
      data-testid="sticky-mobile-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-white/95 border-t border-slate-900/10 px-3 py-2 flex gap-2 shadow-[0_-10px_30px_-15px_rgba(0,0,0,0.2)]"
    >
      <a
        href={TEL_HREF}
        data-testid="sticky-mobile-call"
        className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-orange-600 text-white font-semibold"
      >
        <Phone className="size-4" />
        Call
      </a>
      <a
        href={WHATSAPP_HREF}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-mobile-whatsapp"
        className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-[#25D366] text-white font-semibold"
      >
        <MessageCircle className="size-4" />
        WhatsApp
      </a>
    </div>
  );
}
